export default {
  tabSE: 'DeliveryPortal Sweden',
  tabFI: 'DeliveryPortal Finland',
  tabs: {
    all: 'Alla',
    starred: 'Stjärnmarkerade',
  },
  table: {
    ifsCol: 'IFS',
    nameCol: 'Projektnamn',
    shaftCol: 'Schakt',
    hPCol: 'HP',
    versionCol: 'Version',
    statusCol: 'Senaste versionsstatus',
    published: 'Publicerad',
    notPublished: 'Ej publicerad',
    noProjects: 'Inga projekt hittades, vänligen försök igen.',
    noStarredProjects: 'Du har inga stjärnmarkerade projekt.',
    searchPlacerholder: 'IFS, projektnamn',
    completeProject: 'Klarmarkera projekt',
  },
  informationBox: 'Tabelldata består av Avklarad / Planerad',
  modal: {
    projectCompleted: 'Projekt klarmarkerat!',
    projectCompletion: 'Klarmarkering av projekt',
    ok: 'OK',
    completeProject: 'Klarmarkera projekt',
    cancel: 'Avbryt',
    warningText: {
      1: 'Alla externa användare kommer att tas bort från detta projekt.',
      2: 'Signerade tomtprojekteringar och markavtalsuppgifter kommer att raderas efter ett (1) år.',
      3: 'Är du säker på att du vill klarmarkera detta projekt?',
    },
    confirmCheckboxLabel:
      'Jag är säker, samt bekräftar att signerade tomtprojekteringar är uppladdade till Sharepoint.',
    loading: 'Klarmarkerar projekt. Vänligen vänta...',
    completedInfo:
      'Alla externa har tagits bort från detta projekt. Signerade tomtprojekteringa och markavtalsuppgifter kommer att raderas efter ett (1) år!',
  },
  title: 'Leveransöversikt',
};
